import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { GenerateDocument } from './document.interface';

export class EmployeeDocumentService {
   async getEmployeeDocuments(employeeId: number, query: LocationQuery) {
      return await http
         .get<PaginatedResponse<Document>>(`/employees/${employeeId}/documents`, { params: { ...query } })
         .then((response) => response.data);
   }
   async generateEmployeeDocument(employeeId: number, generateDocument: GenerateDocument) {
      return await http.post<Document>(`/employees/${employeeId}/documents`, generateDocument).then((response) => response.data);
   }
}
